import { useEffect, useState } from "react";

const TICKER = [
  ["AGENTS ONLINE", "1,284"],
  ["MACHINES ACTIVE", "3,912"],
  ["TASKS PROCESSING", "427"],
  ["NETWORK", "ARC"],
];

const SystemStatus = () => {
  const [time, setTime] = useState("");
  useEffect(() => {
    const tick = () => setTime(new Date().toISOString().slice(11, 19) + " UTC");
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div
      data-testid="system-status"
      className="fixed bottom-3 left-3 z-40 hud-panel px-3 py-2 hidden sm:block"
      aria-label="System status: online. Telemetry values are simulated."
    >
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em]">
        <span className="w-1.5 h-1.5 bg-arc-green anim-pulse-dot" aria-hidden="true" />
        <span className="text-arc-cyan">ARCMECH NETWORK</span>
        <span className="text-arc-green">ONLINE</span>
        <span className="text-arc-silver/30">|</span>
        <span className="text-arc-silver/50">{time}</span>
        <span className="text-arc-silver/30">|</span>
        <span className="text-arc-silver/40" title="Simulated interface demo values">SIM</span>
      </div>
      <div className="mt-1 flex gap-3 font-mono text-[9px] tracking-[0.15em] text-arc-silver/40">
        {TICKER.map(([k, v]) => (
          <span key={k}>{k} <span className="text-arc-cyan/80">{v}</span></span>
        ))}
      </div>
    </div>
  );
};

export default SystemStatus;
